export const barChartBase = {
  type: 'bar',
  data: {
    labels: [],
    datasets: [],
    colours: []
  },
  options: {
    responsive: false,
    lineTension: 1,
    scales: {
      xAxes: [{
        stacked: true,
        ticks: {}
      }],
      yAxes: [{
        stacked: true,
        ticks: {
          beginAtZero: true,
          padding: 25,
          userCallback: function (value, index, values) {
            value = value.toString();
            value = value.split(/(?=(?:...)*$)/);
            value = value.join(',');
            return '£' + value;
          }
        }
      }]
    },
    title: {
      display: true,
      position: 'top'
    },
    legend: {
      display: true,
      position: 'right',
      labels: {
        fontColor: 'black',
        fontSize: 12
      }
    },
    tooltips: {
      enabled: true,
      displayColors: true,
      callbacks: {
        label: function (tooltipItem, data) {
          const formatter = new Intl.NumberFormat('en-UK', {
            style: 'currency',
            currency: 'GBP',
            minimumFractionDigits: 0
          })
          
          var label = data.datasets[tooltipItem.datasetIndex].label || '';
          return label + ': ' + formatter.format(tooltipItem.yLabel);
        },
        labelColor: function (tooltipItem, chart) {
          return {
            borderColor: 'white',
            backgroundColor: chart.data.colours[tooltipItem.datasetIndex]
          }
        }
      }
    }
  }
}

export default barChartBase;
